import React, { useState, useEffect } from "react";
import { Pagination, Spin } from "antd";

import config from "appConfig";

import {
  scrollToTop,
  isMobileScreen,
  calculateTotalPagingCount,
  api,
  checkEmptyObject
} from "../../../services";
import styles from "./paginationFinance.scss";

import getWidthContext from "../../../HOCs/getWidthContext";
import FinanceList from "../FinanceList";
import { PaymentMethod, ShoppingCartItemType, ShoppingCartListParsed, ShoppingCartParsed, ShoppingCartStatus } from "../../../models";
import confirmModal from "../../../services/confirmModal";
import BankTransfer from "../../../components/BankTransfer";
import { saveAs } from "file-saver";

export interface IPaginationFinanceProps {
  carts: ShoppingCartListParsed;
  isLoading: boolean;
  handleDeleteCart: (cartId: string) => void;
  handlePageChange: (nextPage: number, pageSize: number) => void;
  handleTabChange: (key: string) => void;
  emptyCartsText?: string;
  width: number;
  activeTab?: string;
}

function PaginationFinance(props: IPaginationFinanceProps) {
  const {
    carts,
    isLoading,
    handleDeleteCart,
    handlePageChange,
    emptyCartsText,
    handleTabChange,
    width,
  } = props;

  const [smallStyle, setSmallStyle] = useState("");
  const isMobile = isMobileScreen(width);

  const handlePageNumberChange = (page: number, pageSize: number) => {
    handlePageChange(page, pageSize);
    scrollToTop();
  };

  const handleTabNumberChange = (key: string) => {
    handleTabChange(key);
    scrollToTop();
  }

  const handleInvoiceDownload = async (cart: ShoppingCartParsed) => {
    try {
      const invoice = await api.Cart.invoice(cart.id);
      saveAs("data:application/pdf;base64," + invoice, `racun-${cart.invoiceId.replace(/\//g, "_")}.pdf`);
    } catch (e) {
      console.error(e);
    }
  }

  const handleAwaitingPayment = async (cart: ShoppingCartParsed) => {
    if (
      cart &&
      cart.paymentMethod === PaymentMethod.bankTransfer &&
      cart.status === ShoppingCartStatus.awaitingPayment &&
      Object.values(ShoppingCartItemType).includes(cart.type) &&
      cart.bankTransferInfo &&
      checkEmptyObject(cart.bankTransferInfo)
    ) {
      confirmModal.show({
        title: "Podaci za uplatu",
        iconType: "NaN",
        width: 610,
        wrapClassName: "bankTransferModal",
        bodyStyle: { padding: '30px 20px 20px' },
        onOk() {
          handleDeleteCart(cart.id);
        },
        cancelText: "Ok",
        okText: "Otkaži narudžbu",
        children: <BankTransfer cart={cart} />
      });
    }
  }

  useEffect(() => {
    if (carts) {
      //set mini pagionation style if total number of pages are between 7 and 9
      (carts.count > config.maxAdPerPage * 7 && carts.count <= config.maxAdPerPage * 9 && isMobile)
        ? setSmallStyle("small") : setSmallStyle("");
    }
  }, [carts]);


  return (
    <React.Fragment>
      <FinanceList
        carts={carts ? carts.data : []}
        emptyCartsText={emptyCartsText}
        isMobile={isMobile}
        isLoading={isLoading}
        onInvoiceDownload={handleInvoiceDownload}
        onAwaitingPayment={handleAwaitingPayment}
        onTabNumberChange={handleTabNumberChange}
        activeTab={props.activeTab}
      />
      {carts && (carts.count > config.maxAdPerPage) ? (
        <div className={styles.pagination}>
          <Pagination
            total={calculateTotalPagingCount(carts.count, carts.page)}
            current={carts.page}
            pageSize={config.maxAdPerPage}
            onChange={handlePageNumberChange}
            size={smallStyle}
            className={styles.pagination}
          />
        </div>
      ) : null}
    </React.Fragment>
  );
}


PaginationFinance.defaultProps = {
  carts: null,
  responsiveProps: {},
  gutter: 0,
  emptyAdsText: undefined,
  paginationClassName: ""
};

export default getWidthContext(PaginationFinance);



// WEBPACK FOOTER //
// ./src/containers/FinancePage/PaginationFinance/index.tsx